import { render, staticRenderFns } from "./UserTicketsPage.vue?vue&type=template&id=44a1911e"
import script from "./UserTicketsPage.vue?vue&type=script&lang=js"
export * from "./UserTicketsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports